export default __webpack_public_path__ + "static/media/tabua-principal.c9c9bd97.webp";